import React, { Component } from "react";
import { Layout } from "antd";
import "./ContentRoutes.css";
import { Route } from "react-router-dom";

import HomePage from '../pages/HomePage';
import CotacoesPage from '../pages/CotacoesPage';
import TarefasPage from '../pages/TarefasPage';
import SobrePage from '../pages/SobrePage';

const { Content } = Layout;

export default class ContentRoutes extends Component {
  state = {};
  render() {
    return (
      <Content className="contentRoutes">
        <div className="contentRoutesContainer">
          <Route path="/" exact component={HomePage} />
          <Route path="/cotacoes" exact component={CotacoesPage} />
          <Route path="/tarefas" exact component={TarefasPage} />
          <Route path="/sobre" exact component={SobrePage} />
        </div>
      </Content>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/ContentRoutes.js